import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { BaseError } from '@utils/types/shared/base.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

export const useDeleteResellerCustomerLogin = (customerId: number) => {
  const queryClient = useQueryClient();

  const deleteResellerCustomerLogin = async (userId: number) => {
    await Axios.delete(
      DELETE_URL(customerId.toString(), userId.toString())
        .deleteResellerCustomerLogin
    );
  };

  return useMutation<void, AxiosError<BaseError>, number>(
    deleteResellerCustomerLogin,
    {
      onSuccess: () => {
        queryClient.invalidateQueries('resellerCustomerLogin');
      },
      onError: () => {
        // Custom error handling
      }
    }
  );
};
